import { Link, Navigate } from "react-router-dom"
import { ExternalLink } from "lucide-react"
import { PageHeader, PageEmpty, PageSpinner, ruledRowLink } from "@/components/page"
import { Button } from "@/components/ui/button"
import { useAuthStore } from "../stores/authStore"
import { useMyCertificates } from "../hooks/useMyCertificates"
import { CertificateRoadmap } from "@/components/academy/CertificateRoadmap"

// /certificados: los certificados de la cuenta. Una sesión de grupo tiene los suyos en
// /grupo/certificados, así que se redirige allí.
export default function MyCertificatesPage() {
  const sessionType = useAuthStore((s) => s.sessionType)
  const isGroup = sessionType === "group"
  const { certificates, state, refetch } = useMyCertificates(!isGroup)

  if (isGroup) return <Navigate to="/grupo/certificados" replace />

  return (
    <div className="space-y-8">
      <PageHeader
        title="Certificados"
        description="Cada certificado tiene un código y una página pública de verificación que puedes compartir."
      />

      {state === "loading" ? (
        <PageSpinner label="Cargando tus certificados" />
      ) : state === "error" ? (
        <PageEmpty
          title="No pudimos cargar tus certificados"
          description="Hubo un problema de conexión. Intenta de nuevo en unos segundos."
          action={<Button onClick={() => refetch()}>Reintentar</Button>}
        />
      ) : certificates.length === 0 ? (
        <CertificateRoadmap />
      ) : (
        <ul className="grid gap-x-10 border-t border-border lg:grid-cols-2 2xl:grid-cols-3">
          {certificates.map((cert) => (
            <li key={cert.id} className="border-b border-border">
              <Link
                to={`/certificates/${cert.certificate_code}`}
                className={`${ruledRowLink} flex min-h-11 items-center gap-3 py-4`}
              >
                <div className="min-w-0 flex-1">
                  <p className="truncate text-base font-medium text-foreground">{cert.course_title}</p>
                  <p className="mt-0.5 text-sm text-muted-foreground">
                    {new Date(cert.issued_at).toLocaleDateString("es-CO", { year: "numeric", month: "long" })}
                  </p>
                </div>
                <ExternalLink
                  className="h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground"
                  aria-hidden="true"
                />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
